import { Moment } from 'moment';

export interface GetThereInputParameters {
    // userInfo: {
    /**
     * Required field. This will need to be the final version. Case sensitive.
     *
     * See `2023-09-21-authentication-with-getthere.md` to understand what we decided to send in this field.
     * TL/DR: we send a unique id for each traveler. When user gets redirected to GetThere Portal, we don't want them to be able to manage travel plans
     * of all patients and caregivers,but just one specific traveler.
     */
    user: string;
    /**
     * Required field. C for current, N for new.
     */
    user_flag: 'c' | 'n';
    /**
     * Required field. "" for domestic travel, "i" for International.
     */
    msg_e: '' | 'i';
    sub_site: 'medpace_guest';
    ss_key: 'newuser';

    // personalInfo: {
    first_name: string;
    middle_i: string;
    last_name: string;
    email: string;
    sfp_birth_year: string;
    sfp_birth_month: string;
    sfp_birth_day: string;
    gender: 'm' | 'f' | '';
    //  };

    // companyInfo: {
    company: string;
    corp_ID: string;
    emp_no: string;
    cost_ctr: string;
    division: string;
    department: string;

    // addressInfo: {
    address: string;
    mail_stop: string;
    city: string;
    state: string;
    zip: string;
    country: string;

    /** Indicates the country code of the country to which the user is traveling.
     * Must use the standard two-character code.
     * Optional for air, required for car or hotel bookings to avoid the user having to fill in the drop-down list for country. */
    countryCode: string;

    day_phone: string;
    home_phone: string;

    //    customFieldsInfo: {

    /** The label in GetThere UI is "Mobile/Cellular Phone" */
    mobile_phone: string;

    /** Displayed as "Job title" in the GetThere UI. */
    position: string;

    /** Business owners decision (#10403): we should always send a constant string `N/A` */
    sfp_known_traveler_number: string;

    /** We should get this value from a "Study code" field in PCS */
    project_code: string;

    /** We should get this value from a "Site #" field in PCS */
    site_num: string;

    /** We should get this value from a "Patient Id" field in PCS */
    patient_id: string;

    /** We should get this value from a "Visit name" field in PCS */
    visit_num: string;

    /** The format of the string should be: "DD-MMM-YYYY, Example: 20-Feb-2021" */
    date_visit: string;

    //  tripInfo: {

    /* Specifies whether air [travel] is needed.  Valid values are “yes” or “no” */
    need_air: 'yes' | 'no';

    // airSearchCriteria: {
    tripType: 'roundTrip' | 'oneWay' | 'multipledestination' | '';
    cabinClass: CabinClass;
    pricingType: PricingType;

    need_hotel: 'yes' | 'no';
    need_car: 'yes' | 'no';
    need_rail: 'yes' | 'no';
    numPassengers: number;

    origin: string;
    destination: string;
    departureDate: Moment;
    returnDate: Moment;
    departureTravelMethod: 'departs' | 'arrives' | '';
    returnTravelMethod: 'departs' | 'arrives' | '';
    //  errorHandling: {
    err_url: string;
}

export enum PricingType {
    LowestAvailable = 1,
    NoAdvancePurchase = 2,
    NoPenalty = 3,
    Unrestricted = 4,
}
export enum CabinClass {
    Coach = 1,
    Business = 2,
    First = 3,
}
